import React from 'react'
import ReactDOM from 'react-dom'
import AboutBroadsheet from '../../../site/layout/component/AboutBroadsheet'
import ThemeContext from '../../../site/layout/component/Theme/ThemeContext'

const debug = require('debug')('aboutBroadsheet')

export default () => {
  debug('init')
  document.addEventListener('DOMContentLoaded', () => {
    const theme = document.querySelector('body').dataset.theme

    document.querySelectorAll('.js-about-broadsheet').forEach(appNode => {
      const props = JSON.parse(appNode.getAttribute('data-props') || '{}')
      ReactDOM.render(
        <ThemeContext.Provider value={theme}>
          <AboutBroadsheet {...props} />
        </ThemeContext.Provider>,
        appNode
      )
    })
  })
}
